import React, { useMemo, useState } from 'react';
import ChipInput from 'material-ui-chip-input';
import { defaultChipRenderer } from 'material-ui-chip-input/lib/ChipInput';
import { Geography } from '../AttributesDialog';

import {
  ClickAwayListener,
  Collapse,
  FormControl,
  Paper,
} from '@material-ui/core';
import { RootStateOrAny, useSelector } from 'react-redux';

import useStyles from './styles';

export function RBIChipsInput({
  label,
  value,
  invariants = [],
  children,
  externalClasses = [],
  getChipText = (item: any) => item?.text,
  containerStyle = {},
  disabled = false,
  onChange = (arg: any[]) => {},
  onExpandedChange = (expanded: boolean) => {},
  onBeforeDelete = (item: any) => Promise.resolve(true),
  onFocus = () => {},
  onBlur = () => {},
  required=false
}) {
  const classes = useStyles();

  const { thisUser } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );

  const [inputValue, setInputValue] = useState('');
  const [expanded, setExpanded] = useState(false);

  const handleClose = () => {
    setExpanded(false);
  };
  const handleOpen = () => {
    if (disabled) return;
    if (thisUser.hasViewEquipment && !thisUser.hasEditEquipment) {
      setExpanded(false);
    } else {
      setExpanded(true);
    }
  };
  const handleChange = async (item, index) => {
    if (await onBeforeDelete(value[index])) {
      const values = [...value];
      values.splice(index, 1);
      onChange(values);
    }
  };
  const handleEntered = () => {
    onExpandedChange(expanded);
  };

  const chips = useMemo(() => value.map(getChipText), [value, getChipText]);

  const chipRenderer = (props, key) => {
    const invariantTexts = (invariants as Geography[]).map((i) => i.text);
    const deletable = !invariantTexts.includes(props.text);
    const finalHandleDelete = deletable ? props.handleDelete : undefined;
    return defaultChipRenderer({ ...props, handleDelete: finalHandleDelete }, key);
  }

  return (
    <FormControl fullWidth variant="outlined" disabled={disabled}>
      <ClickAwayListener
        mouseEvent="onMouseDown"
        touchEvent="onTouchStart"
        onClickAway={handleClose}
      >
        <div>
          <ChipInput
            label={label}
            value={chips}
            variant="outlined"
            fullWidth
            required={required}
            disabled={disabled}
            onClick={handleOpen}
            onDelete={handleChange}
            InputProps={{
              className:externalClasses.join(' '),
              inputProps:{ 'data-testid': `countryRegionSelector-chipInput` }
            }}
            className={`${classes.chipInput}`}
            inputValue={inputValue}
            onUpdateInput={() => setInputValue('')}
            onFocus={onFocus}
            onBlur={onBlur}
            chipRenderer={chipRenderer}
          />
          <Collapse
            in={expanded}
            timeout="auto"
            disableStrictModeCompat
            onEntered={handleEntered}
          >
            <Paper style={containerStyle} className={classes.paperStyle}>
              {children}
            </Paper>
          </Collapse>
        </div>
      </ClickAwayListener>
    </FormControl>
  );
}
